import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'link'
});
export var Link = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'a' : _ref$as,
      to = _ref.to,
      text = _ref.text,
      newTab = _ref.newTab,
      props = _objectWithoutProperties(_ref, ["as", "to", "text", "newTab"]);

  var variant = 'base';
  return _jsx(As, _objectSpread(_objectSpread({
    ref: ref,
    href: to,
    target: !newTab ? '_self' : '_blank',
    sx: {
      cursor: 'pointer',
      variant: variantPath(variant),
      ':hover, ._force-hover &': {
        variant: variantPath(variant, 'hover')
      },
      ':focus, ._force-focus &': {
        variant: variantPath(variant, 'focus')
      }
    },
    rel: "noreferrer"
  }, props), {}, {
    children: text || to
  }));
});
Link.propTypes = {
  /**
   * Where to link to?
   */
  to: PropTypes.string,

  /**
   * Text to display? If this is not set `to` prop will be used
   */
  text: PropTypes.string,

  /**
   * Open link destination in new tab?
   */
  newTab: PropTypes.bool
};
Link.defaultProps = {
  newTab: false
};
Link.displayName = 'Link';